export default (f, t) => {
  let lastCall, lastCallTimer;
  return function (args) {
    console.log('DEBOUNCE', t)
    let previousCall = lastCall;
    lastCall = Date.now();
    if (previousCall && ((lastCall - previousCall) <= t)) {
      clearTimeout(lastCallTimer);
    }
    lastCallTimer = setTimeout(() => f(args), t);
  }
}
